export const BEHAVIOR_CHANGED_EVENT = "trustbud:behavior-changed";

export function getBehaviorInvalidationTargets(eventType, { hasSprint = false } = {}) {
  const shared = ["today", "plan", "weekly-summary", "dashboard", "intervention"];

  if (eventType === "action_completed" || eventType === "action_undone") {
    return hasSprint ? [...shared, "sprint", "network", "connections"] : shared;
  }
  if (eventType === "checkin_created") {
    return hasSprint ? [...shared, "sprint", "network"] : shared;
  }
  if (
    eventType === "short_update_sent" ||
    eventType === "repair_update_sent" ||
    eventType === "sprint_started" ||
    eventType === "sprint_renewed" ||
    eventType === "sprint_closed"
  ) {
    return ["today", "sprint", "network", "connections", "dashboard", "intervention"];
  }

  return shared;
}

export function dispatchBehaviorChanged(detail = {}) {
  if (typeof window === "undefined") return;
  const payload = {
    ...detail,
    targets: getBehaviorInvalidationTargets(detail?.eventType, {
      hasSprint: Boolean(detail?.hasSprint),
    }),
  };
  window.dispatchEvent(new CustomEvent(BEHAVIOR_CHANGED_EVENT, { detail: payload }));
  window.dispatchEvent(new Event("trustbud:changed"));
  if (payload.targets.includes("sprint") || payload.targets.includes("connections")) {
    window.dispatchEvent(new Event("trustbud:connections-changed"));
  }
}
